import { Tag } from 'antd';
import {
  stockBalanceHistoriesStatusOptions,
  stockBalanceHistoriesTypeColors,
  stockBalanceHistoriesTypeOptions,
  stockBalanceHistoryStatusColors,
  stockBalanceHistoryStatusLabels,
} from 'apps/investment/constants/stock-balance-histories';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import { FilterFieldConfig } from 'common/dynamic-filter-form';
import {
  currencyCell,
  dateCell,
  dateTimeCell,
  linkCell,
  userCell,
} from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/investment/stock-balance-histories' }),
  },
  {
    accessorKey: 'trade_date',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Trade Date" />
    ),
    cell: dateCell,
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'type',
    header: 'Type',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue, row }) => {
      const value = getValue();
      const label = row.original?.type_label;
      return (
        <Tag className="mx-auto" color={stockBalanceHistoriesTypeColors[value]}>
          {label || value}
        </Tag>
      );
    },
  },
  {
    accessorKey: 'amount',
    header: 'Amount',
    meta: {
      className: 'text-right',
    },
    cell: currencyCell,
  },
  {
    accessorKey: 'balance',
    header: 'Balance',
    meta: {
      className: 'text-right',
    },
    cell: currencyCell,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <Tag className="mx-auto" color={stockBalanceHistoryStatusColors[value]}>
          {stockBalanceHistoryStatusLabels[value] || value}
        </Tag>
      );
    },
  },
  {
    accessorKey: 'note',
    header: 'Note',
  },

  {
    accessorKey: 'user',
    header: 'User',
    cell: userCell,
  },
  {
    accessorKey: 'stock_seq_no',
    header: 'Stock Seq No',
    meta: {
      className: 'text-right',
    },
  },
  {
    accessorKey: 'stock_sub_no',
    header: 'Stock Sub No',
    meta: {
      className: 'text-right',
    },
  },
];

export const filterConfig: FilterFieldConfig[] = [
  {
    name: 'type',
    type: 'select',
    label: 'Type',
    placeholder: 'All',
    minWidth: '120px',
    options: stockBalanceHistoriesTypeOptions,
    defaultValue: 'all',
  },
  {
    name: 'status',
    type: 'select',
    label: 'Status',
    placeholder: 'All',
    minWidth: '120px',
    options: stockBalanceHistoriesStatusOptions,
    defaultValue: 'all',
  },
];
